import angular from 'angular';
import onboardingComponent from './onboarding.component';

let onboardingModule = angular.module('onboarding', []).component('onboarding', onboardingComponent);

export default onboardingModule;



// WEBPACK FOOTER //
// ./app/components/onboarding/onboarding.js